const closePopup = () => {
    return {
        type: "CLOSE_POPUP",
        payload: {}
    }
};

const openRegisterSuccessPopup = () => {
    return {
        type: "OPEN_REGISTER_SUCCESS_POPUP",
        payload: {}
    }
};

const openSuccessPopup = (payload) => {
    return {
        type: "OPEN_SUCCESS_POPUP",
        payload: payload
    }
};

const openFailPopup = (payload) => {
    return {
        type: "OPEN_FAIL_POPUP",
        payload: payload
    }
};

const openFeedbackPopup = (payload) => {
    return {
        type: "OPEN_FEEDBACK_POPUP",
        payload: payload
    }
};

export {closePopup, openRegisterSuccessPopup, openSuccessPopup, openFeedbackPopup, openFailPopup};


// WEBPACK FOOTER //
// ./src/actions/Popup.js